import type {
  ClientAccessDto,
  ClientProfilePatch,
  GrantClientAccessRequest,
  ManagerClientDetail,
  ManagerClientListItem,
  ManagerClientsQuery,
  ManagerOption,
  OrderCreateInput,
  OrderDetail,
} from '@expeditor/shared';
import { apiClient } from './client';

export const managerClientsApi = {
  list(query: ManagerClientsQuery = {}): Promise<ManagerClientListItem[]> {
    const params: Record<string, string> = {};
    if (query.search) params.search = query.search;
    if (query.includeDeregistered) params.includeDeregistered = 'true';
    if (query.mineOnly) params.mineOnly = 'true';
    return apiClient
      .get<ManagerClientListItem[]>('/manager/clients', { params })
      .then((r) => r.data);
  },
  getOne(id: string): Promise<ManagerClientDetail> {
    return apiClient.get<ManagerClientDetail>(`/manager/clients/${id}`).then((r) => r.data);
  },
  listManagers(): Promise<ManagerOption[]> {
    return apiClient
      .get<ManagerOption[]>('/manager/clients/managers/options')
      .then((r) => r.data);
  },
  setResponsibleManager(
    clientId: string,
    managerId: string | null,
  ): Promise<ManagerClientDetail> {
    return apiClient
      .patch<ManagerClientDetail>(`/manager/clients/${clientId}/responsible-manager`, {
        managerId,
      })
      .then((r) => r.data);
  },
  listAccess(clientId: string): Promise<ClientAccessDto[]> {
    return apiClient
      .get<ClientAccessDto[]>(`/manager/clients/${clientId}/access`)
      .then((r) => r.data);
  },
  grantAccess(
    clientId: string,
    dto: GrantClientAccessRequest,
  ): Promise<ClientAccessDto> {
    return apiClient
      .post<ClientAccessDto>(`/manager/clients/${clientId}/access`, dto)
      .then((r) => r.data);
  },
  revokeAccess(clientId: string, accessId: string): Promise<void> {
    return apiClient
      .delete<void>(`/manager/clients/${clientId}/access/${accessId}`)
      .then(() => undefined);
  },
  /** Правка данных клиента от имени клиента (нужно право canActForClients). */
  updateProfile(clientId: string, patch: ClientProfilePatch): Promise<{ changes: unknown[] }> {
    return apiClient
      .patch<{ changes: unknown[] }>(`/manager/clients/${clientId}/profile`, patch)
      .then((r) => r.data);
  },
  /** Создание поручения за клиента. */
  createOrder(clientId: string, dto: OrderCreateInput): Promise<OrderDetail> {
    return apiClient
      .post<OrderDetail>(`/manager/clients/${clientId}/orders`, dto)
      .then((r) => r.data);
  },
};
